export const categories = [
  { slug: 'movie', name: '电影', icon: 'ri-movie-2-line', color: 'bg-rose-100 text-rose-700' },
  { slug: 'tv', name: '电视剧', icon: 'ri-tv-2-line', color: 'bg-amber-100 text-amber-700' },
  { slug: 'variety', name: '综艺', icon: 'ri-emotion-laugh-line', color: 'bg-emerald-100 text-emerald-700' },
  { slug: 'anime', name: '动漫', icon: 'ri-rocket-2-line', color: 'bg-violet-100 text-violet-700' },
  { slug: 'documentary', name: '纪录片', icon: 'ri-earth-line', color: 'bg-cyan-100 text-cyan-700' },
  { slug: 'kids', name: '少儿', icon: 'ri-bear-smile-line', color: 'bg-orange-100 text-orange-700' },
  { slug: 'sports', name: '体育', icon: 'ri-basketball-line', color: 'bg-sky-100 text-sky-700' },
  { slug: 'music', name: '音乐', icon: 'ri-music-2-line', color: 'bg-pink-100 text-pink-700' },
];

export const heroStats = [
  { label: '注册会员', value: '500万+', icon: 'ri-user-star-line' },
  { label: '正版视频', value: '10万+', icon: 'ri-film-line' },
  { label: '内容分类', value: '20+', icon: 'ri-grid-line' },
];

export const featuredVideos = [
  {
    id: 1,
    title: '星际穿越',
    category: '电影',
    categorySlug: 'movie',
    thumbnail: 'https://readdy.ai/api/search-image?query=Epic%20science%20fiction%20space%20exploration%20movie%20scene%20with%20astronaut%20floating%20near%20a%20massive%20black%20hole%20wormhole%20in%20deep%20space%20cinematic%20lighting%20dramatic%20composition%20film%20poster%20style&width=640&height=360&seq=featured-1&orientation=landscape',
    rating: 9.4,
    views: '1280万',
    isVip: false,
    duration: '169分钟',
    description: '一部震撼人心的科幻史诗，讲述人类穿越虫洞探索新家园的伟大旅程。',
  },
  {
    id: 2,
    title: '舌尖上的中国·第四季',
    category: '纪录片',
    categorySlug: 'documentary',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20food%20documentary%20scene%20with%20traditional%20cuisine%20cooking%20in%20rustic%20kitchen%20steaming%20hot%20dishes%20warm%20ambient%20lighting%20rich%20colors%20cinematic%20food%20photography&width=640&height=360&seq=featured-2&orientation=landscape',
    rating: 9.6,
    views: '3500万',
    isVip: true,
    duration: '50分钟/集',
    description: '探访中国各地美食文化，记录人与食物之间最动人的故事。',
  },
  {
    id: 3,
    title: '王者之路',
    category: '综艺',
    categorySlug: 'variety',
    thumbnail: 'https://readdy.ai/api/search-image?query=Exciting%20variety%20show%20stage%20with%20colorful%20lighting%20and%20energetic%20performers%20dancing%20on%20a%20grand%20stage%20with%20live%20audience%20dynamic%20atmosphere%20entertainment%20show&width=640&height=360&seq=featured-3&orientation=landscape',
    rating: 8.9,
    views: '2100万',
    isVip: false,
    duration: '90分钟/期',
    description: '顶级音乐竞技综艺，实力唱将同台对决，精彩不容错过。',
  },
  {
    id: 4,
    title: '灵笼·终章',
    category: '动漫',
    categorySlug: 'anime',
    thumbnail: 'https://readdy.ai/api/search-image?query=Futuristic%20Chinese%20animation%20sci-fi%20scene%20with%20post%20apocalyptic%20cityscape%20floating%20in%20the%20sky%20mechanical%20structures%20dramatic%20orange%20and%20teal%20color%20grading%20epic%20anime%20art%20style&width=640&height=360&seq=featured-4&orientation=landscape',
    rating: 9.2,
    views: '5600万',
    isVip: true,
    duration: '25分钟/集',
    description: '国产科幻动画巅峰之作，末日世界中人类为生存而战的史诗故事。',
  },
  {
    id: 5,
    title: '长津湖之水门桥',
    category: '电影',
    categorySlug: 'movie',
    thumbnail: 'https://readdy.ai/api/search-image?query=Epic%20historical%20war%20film%20scene%20with%20soldiers%20in%20winter%20battlefield%20snow%20covered%20mountains%20dramatic%20cinematic%20lighting%20heroic%20composition%20film%20poster%20style%20intense%20atmosphere&width=640&height=360&seq=featured-5&orientation=landscape',
    rating: 9.3,
    views: '4200万',
    isVip: false,
    duration: '149分钟',
    description: '抗美援朝战争中的壮烈一战，展现中国军人的钢铁意志。',
  },
  {
    id: 6,
    title: '流浪地球3',
    category: '电影',
    categorySlug: 'movie',
    thumbnail: 'https://readdy.ai/api/search-image?query=Grand%20science%20fiction%20film%20scene%20with%20Earth%20moving%20through%20space%20powered%20by%20massive%20engines%20blue%20glowing%20thrusters%20surrounded%20by%20Jupiter%20cinematic%20epic%20scale%20dramatic%20lighting&width=640&height=360&seq=featured-6&orientation=landscape',
    rating: 9.0,
    views: '6800万',
    isVip: true,
    duration: '173分钟',
    description: '人类带着地球去流浪，宇宙尺度的想象力令人叹为观止。',
  },
];

export const membershipPlans = [
  {
    id: 'monthly',
    name: '月度会员',
    price: '25',
    originalPrice: '30',
    period: '月',
    features: ['海量正版内容', '超清1080P画质', '无广告干扰'],
    highlighted: false,
  },
  {
    id: 'quarterly',
    name: '季度会员',
    price: '68',
    originalPrice: '90',
    period: '季',
    features: ['海量正版内容', '超清4K画质', '无广告干扰', '多终端同步'],
    highlighted: true,
    badge: '热门',
  },
  {
    id: 'yearly',
    name: '年度会员',
    price: '228',
    originalPrice: '360',
    period: '年',
    features: ['海量正版内容', '超清4K画质', '无广告干扰', '多终端同步', '离线下载', '专属客服'],
    highlighted: false,
  },
];

export const brandAdvantages = [
  {
    id: 'genuine',
    icon: 'ri-shield-check-line',
    title: '正版授权',
    description: '所有内容均获得正版授权，为您提供合法、安全的观影体验，支持创作者和版权方。',
  },
  {
    id: 'quality',
    icon: 'ri-4k-line',
    title: '超清画质',
    description: '支持1080P至4K超清画质播放，智能适配网络环境，自动调节最佳清晰度。',
  },
  {
    id: 'multiDevice',
    icon: 'ri-device-line',
    title: '多端同步',
    description: '手机、平板、电脑、电视全覆盖，观影记录和收藏自动云端同步，随时随地继续观看。',
  },
  {
    id: 'offline',
    icon: 'ri-download-cloud-2-line',
    title: '离线下载',
    description: '会员支持视频离线下载，无网络环境也能畅享精彩内容，通勤出行不再无聊。',
  },
];

export const faqs = [
  {
    q: '爱液视频支持哪些设备观看？',
    a: '爱液视频支持手机（iOS/Android）、平板、电脑（Windows/Mac）以及智能电视等多种设备，一个账号即可在所有设备上同步使用。',
  },
  {
    q: '会员订阅后可以随时取消吗？',
    a: '可以的，您可以在会员到期前随时取消自动续费，取消后当前会员周期内的权益不受影响，仍然可以正常使用至到期日。',
  },
  {
    q: '视频画质支持哪些清晰度？',
    a: '我们支持流畅、标清、高清、超清1080P以及4K等多种清晰度选项，系统会根据您的网络环境智能推荐最佳画质。',
  },
  {
    q: '如何联系客服获取帮助？',
    a: '您可以通过官网在线客服、官方邮箱service@aiyivideo.com或拨打客服热线400-888-8888联系我们，客服工作时间为每天9:00-21:00。',
  },
  {
    q: '支持哪些支付方式？',
    a: '我们支持微信支付、支付宝、银联卡以及Apple Pay等多种支付方式，确保您的支付安全便捷。',
  },
];